import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { RouteComponentProps } from 'react-router-dom'
import { getFunctionCheckList } from 'features/checklist/unit/api'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { Function } from 'features/checklist/unit/types'
import {
  deleteFunctionReq,
  updateFuncDetail,
} from 'features/checklist/unit/actions'
import { AlertError } from 'Components/Shared'
import EventModal from 'Components/Shared/Modal/EventModal'
import { BreadcrumbLink } from 'Components/Shared/BreadCrumb/BreadCrumb'
import DeleteModal, {
  DeleteModalHandles,
} from 'Components/Shared/Modal/DeleteModal'
import {
  LineHeader,
  TableHeader,
  TableColHeader,
} from 'Components/Shared/Table'
import Pagination from 'Components/Shared/Pagination'
import SubnavBar from 'Components/Shared/SubnavBar'

import Menu from '../../../MenuAdmin'
import RowItem from './RowItem'

import { toCheckList } from 'importer/func'
import { SearchInput } from 'Components/Filter'

const breadcrumbs: BreadcrumbLink[] = [
  {
    url: '/dashboard',
    title: 'Home',
    icon: '/home.png',
    active: true,
    showTitle: false,
  },
  {
    url: '/check-function',
    title: 'ตรวจ function',
    active: false,
    showTitle: false,
  },
]

type Props = DispatchProps & ReduxProps & RouteComponentProps

const QCCheckFunction: React.ComponentType<Props> = ({
  history,
  event,
  getFunctionCheckList,
  functionList,
  deleteFunction,
}) => {
  const modalRef = useRef<DeleteModalHandles>(null)
  const [enableModal, setEnableModal] = useState(false)
  const [err, setErr] = useState(undefined)
  const deleteItem = useRef<Function | null>(null)
  const [searchText, setSearchText] = useState('')
  const [pagination, setPagination] = useState<{
    Page: number
    RowPerPage: number
  }>({
    Page: 1,
    RowPerPage: 10,
  })

  const dispatch = useDispatch()

  const onDelete = async () => {
    if (deleteItem.current) {
      setEnableModal(true)
      deleteFunction(deleteItem.current.CheckListID, pagination)
    }
  }

  const showDeleteModal = (item: Function) => {
    if (modalRef.current) {
      modalRef.current.showModal('คุณยืนยันต้องการลบ funtion นี้', 0)
      deleteItem.current = item
    }
  }

  const onImport = (data: any) => {
    try {
      const checklist = toCheckList(data)
      dispatch(updateFuncDetail(checklist))
      history.push('/check-function/create')
    } catch (e) {
      console.log('import err:', e.message)
      setErr(e.message)
    }
  }

  const content = functionList.List.map((item: any, index: number) => {
    return <RowItem key={index} item={item} showDeleteModal={showDeleteModal} />
  })

  useEffect(() => {
    getFunctionCheckList(pagination.Page, pagination.RowPerPage, searchText)
  }, [pagination])

  const onRefreshPage = () => {
    setEnableModal(false)
    getFunctionCheckList(pagination.Page, pagination.RowPerPage)
  }

  const closeEnableModal = () => setEnableModal(false)

  const onSearch = (val: string) => {
    if (searchText === '' && val === '') return
    setSearchText(val)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  return (
    <>
      <EventModal
        event={[event]}
        enable={enableModal}
        successCalback={onRefreshPage}
        errorCalback={closeEnableModal}
      />

      <AlertError
        isShow={err !== undefined}
        text={err}
        callback={() => setErr(undefined)}
      />
      <SubnavBar
        breadcrumbs={breadcrumbs}
        hideSearch={true}
        adminSearchBox={<SearchInput onSearch={onSearch} />}
      />
      <Menu selected="check-function">
        <MainPage>
          <LineHeader
            title="ตรวจ Function"
            textImport="นำเข้า Checklist"
            textCreate="สร้าง Checklist ใหม่"
            onCreate={() => history.push('./check-function/create')}
            onImport={onImport}
          />

          <TableHeader>
            <TableColHeader span={6} isPadding={true}>
              Checklist name
            </TableColHeader>
            <TableColHeader span={3}>ประเภทโครงการ</TableColHeader>
            <TableColHeader span={4}>จำนวนโครงการที่ใช้งาน</TableColHeader>
            <TableColHeader span={3}>วันที่สร้าง</TableColHeader>
            <TableColHeader span={4}>แก้ไขล่าสุด</TableColHeader>
            <TableColHeader span={4}>Action</TableColHeader>
          </TableHeader>
          {content}
          <Pagination
            currentPage={pagination.Page}
            totalRows={functionList.TotalRows}
            perPage={pagination.RowPerPage}
            onChangeNumber={(row: number) => {
              pagination.RowPerPage = row
              setPagination({ ...pagination })
            }}
            onClickPage={(page: number) => {
              pagination.Page = page
              setPagination({ ...pagination })
            }}
          />
        </MainPage>
      </Menu>
      <DeleteModal ref={modalRef} onOk={onDelete} />
    </>
  )
}

const MainPage = styled.div`
  padding: 40px 45px;
  width: 100%;
`

type ReduxProps = ReturnType<typeof mapStateToProps>
const mapStateToProps = (state: RootState) => {
  return {
    event: state.unitChecklist.Event,
    functionList: state.unitChecklist.FunctionList,
  }
}

const mapDispatchToProps = {
  getFunctionCheckList,
  deleteFunction: (id: number, pagination: any) =>
    deleteFunctionReq.request({ id, pagination }),
}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(QCCheckFunction)
